import React, { memo, useEffect, useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import DeleteCustomerAddressModal from './DeleteCustomerAddress/DeleteCustomerAddressModal'
import CustomerAddressModal from './AddCustomerAddress/CustomerAddressModal'
import CustomerDefaultAddress from './CustomerDefaultAddress'
import DefaultCustomerAddressModel from './DefaultCustomerAddressModel';
import AddressTable from './AddressTable';

function CustomersAddresses(props) {
    const { getCustomerAddresses_, addressess, countries = [], customer } = props
    const [selAddress, setAddress] = useState({})

    const [add, setAdd] = useState(false)
    const [dlt, setDlt] = useState(false)
    const [defaultAdd, setDefaultAdd] = useState(false)
    const [id, setId] = useState("");

    const bAddress = addressess.filter(e => e.address_type === "Billing")
    const sAddress = addressess.filter(e => e.address_type === "Shipping")
    useEffect(() => {
        let customerId = props.id
        if (!props.id) {
            // customerId = props.match.params.id
        }
        setId(customerId)
    }, [props.id])



    return (
        <React.Fragment>
            <div className="app-header-wrapper heading-sm pad-15 d-flex  justify-content-between pb-0">
                <p className="app-heading text-uppercase st-text-light st-fs-16 st-fw-700">Addresses</p>
                <button
                    onClick={() => {
                        setAddress({})
                        setAdd(true)
                    }}
                    to="/customers/group/create"
                    className="st-btn st-btn-primary no-min-width st-btn-sm d-flex align-items-center justify-content-center btn btn-primary">
                    <span>Add New Address</span>
                </button>
            </div>
            <Col xs={12} md={12} lg={12} className="px-0">
                {add && <CustomerAddressModal
                    show={add}
                    userId={id}
                    closeModal={() => {
                        setAddress({})
                        setAdd(false)
                    }}
                    onSave={() => {
                        getCustomerAddresses_(id)
                    }}
                    addressData={selAddress}
                    countries={countries}
                    customer={customer}
                />}
                {dlt && <DeleteCustomerAddressModal
                    show={dlt}
                    onSave={() => {
                        getCustomerAddresses_(id)
                    }}
                    address_id={selAddress.address_id}

                    closeModal={() => {
                        setAddress({})
                        setDlt(false)
                    }}
                />}
                {defaultAdd && <DefaultCustomerAddressModel
                    show={defaultAdd}
                    onSave={() => {
                        getCustomerAddresses_(id)
                    }}
                    address_id={selAddress.address_id}
                    closeModal={() => {
                        setAddress({})
                        setDefaultAdd(false)
                    }}
                />}

                <Row className="pad-20-R pad-12-L">
                    {(addressess.filter(e => e.is_default && e.address_type === "Billing")[0]) && <Col lg={6}>
                        <CustomerDefaultAddress
                            address={addressess.filter(e => e.is_default && e.address_type === "Billing")[0]}
                            countries={countries}
                            refreshAddress={getCustomerAddresses_} />
                    </Col>}
                    <Col lg={6}>
                        <CustomerDefaultAddress
                            address={addressess.filter(e => e.is_default && e.address_type === "Shipping")[0]}
                            countries={countries}
                            refreshAddress={getCustomerAddresses_} />
                    </Col>
                </Row >
                {/* <AddressTableTopBar /> */}
                <AddressTable
                    address={bAddress}
                    setAddress={setAddress}
                    dlt={dlt}
                    setDlt={setDlt}
                    id={id}
                    setId={setId}
                    add={add}
                    setAdd={setAdd}
                    defaultAdd={defaultAdd}
                    setDefaultAdd={setDefaultAdd}
                    getCustomerAddresses_={getCustomerAddresses_}
                    title={"Billing"}
                />
                <AddressTable
                    address={sAddress}
                    setAddress={setAddress}
                    dlt={dlt}
                    setDlt={setDlt}
                    id={id}
                    setId={setId}
                    add={add}
                    setAdd={setAdd}
                    defaultAdd={defaultAdd}
                    setDefaultAdd={setDefaultAdd}
                    getCustomerAddresses_={getCustomerAddresses_}
                    title={"Shipping"}
                />
            </Col >
        </React.Fragment>
    )
}

export default memo(CustomersAddresses)